import { useAtom } from 'jotai'
import React from 'react'

import {
  ToggleRadioButtonGroup,
  type ToggleRadioButtonGroupProps,
} from '~/components/elements/ToggleRadioButtonGroup'

import { tableChartTypeAtom } from '../../atoms'
import { type TableChartType } from '../../utils'

type Attribute =
  ToggleRadioButtonGroupProps<TableChartType>['attributes'][number]

const attributes = [
  { icon: 'chart-line-markers', value: 'chart' },
  { icon: 'table', value: 'table' },
] satisfies Attribute[]

export const TableChartSwitcher = () => {
  const [tableChartType, setChartType] = useAtom(tableChartTypeAtom)

  return (
    <ToggleRadioButtonGroup
      attributes={attributes}
      value={tableChartType}
      onChange={setChartType}
    />
  )
}
